
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, TableBody, Grid, TableCell, CircularProgress, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useMemo, useCallback } from 'react';
import { debounce } from 'lodash'; 
import { useAccesos } from '../contexts/AccesosContext';

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function NewOportunidad (handleSeleccionarOportunidad){
     // Estado para el título, descripción y selección del ComboBox
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [nombreOportunidad, setNombreOportunidad] = useState('');
    const [valorMonetario, setValorMonetario] = useState('');
    const [fechaCierre, setFechaCierre] = useState('');
    const [selectedEtapa, setSelectedEtapa] = useState(null);
    const [etapas, setEtapas] = useState([]);
    const [probabilidad, setProbabilidad] = useState(''); 
    const [selectedCliente, setSelectedCliente] = useState(false);
    const [clientes, setClientes] = useState([]);
    const [selectedOrigen, setSelectedOrigen] = useState(null);
    const [origenes, setOrigenes] = useState([]);
    const [selectedOrden, setSelectedOrden] = useState(null);
    const [ordenes, setOrdenes] = useState([]);
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [selectedSucursal, setSelectedSucursal] = useState(null);
    const [sucursales, setSucursales] = useState([]);


    const [isLoading, setIsLoading] = useState(false);
    const [totalClientes, setTotalClientes] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [inputValue, setInputValue] = useState('');

     const { user } = useUser();
     const { tienePermiso } = useAccesos();
         // Obtener la fecha y hora actual
         function obtenerFechaISOsinZ() {
           const fecha = new Date();
           let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
           fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
           return fechaISO;
       }


 
     const fetchEtapasOportunidad = async () => {
      try {
        const response = await fetch(`${server}/CrmEtapaOportunidads`);
        const data = await response.json();
        setEtapas(data.$values || []);
      } catch (error) {
        console.error("Error al obtener etapas:", error);
      }
    };

     const debouncedFetchClientes = useMemo(
            () =>
                debounce((searchText) => {
                    fetchClientes(searchText);
                }, 500),
            []
        );

     // Manejar el cambio en el input del Autocomplete
    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
        debouncedFetchClientes(newInputValue);
    };




    //  const fetchClientes = async () => {
    //   try {
    //     const response = await fetch(`${server}/MgClientes`);
    //     const data = await response.json();
    //     setClientes(data.$values || []);
    //   } catch (error) {
    //     console.error("Error al obtener clientes:", error);
    //   }
    // };

    const fetchClientes = async (search = '') => {
        try {
            setIsLoading(true);
            const response = await fetch(`${server}/MgClientes/buscador/${search}`);
            const data = await response.json();

            if (data && data.clientes && Array.isArray(data.clientes.$values)) {
                const clientesData = data.clientes.$values;

                setClientes(clientesData);
                setTotalClientes(data.total);
                setHasMore(clientesData.length >= limit);
            } else {
                setClientes([]);
                setHasMore(false);
            }
        } catch (error) {
            console.error('Error al obtener los clientes:', error);
        } finally {
            setIsLoading(false);
        }
    };


     const fetchOrigenes = async () => {
      try {
        const response = await fetch(`${server}/MgOrigenes`);
        const data = await response.json();
        setOrigenes(data.$values || []);
      } catch (error) {
        console.error("Error al obtener gastos:", error);
      }
    };

    const fetchSucursales = async () => {
      try {
        const response = await fetch(`${server}/MgSucursales`);
        const data = await response.json();
        setSucursales(data.$values || []);
      } catch (error) {
        console.error("Error al obtener gastos:", error);
      }
    };

    //  const fetchOrdenes= async (idCampania) => {
    //   try {
    //     const response = await fetch(`${server}/MgOrigenes`);
    //     const data = await response.json();
    //     setGastos(data.$values || []);
    //   } catch (error) {
    //     console.error("Error al obtener gastos:", error);
    //   }
    // };

    const handleClienteSeleccionado = (event, newValue) => {
    setSelectedCliente(newValue); // Guarda el objeto cliente seleccionado
};

    useEffect(() => {
        fetchEtapasOportunidad();
        fetchClientes();
        fetchOrigenes();
        fetchSucursales();

    }, []);
    const fechaFormateada = obtenerFechaISOsinZ();
    const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      nombreOportunidad &&
      valorMonetario &&
      fechaCierre &&
      selectedEtapa &&
      selectedCliente &&
    //   selectedCliente &&
      selectedOrigen &&
      selectedSucursal
      
    ) {
      const nuevaOportunidad = {
        nombreOportunidad,
        valorMonetario,
        fechaCierre,
        // probabilidad,
        
        idEtapaOportunidad: selectedEtapa.id,
        idCliente: selectedCliente.idCliente,
        idOrigen: selectedOrigen.idOrigen,
        idSucursal: selectedSucursal.idSucursal,
        IngresadoPor: user ? user.codigoUsuario : 'ADMIN               ',
        ModificadoPor: null,
        modificacion: 1,
        fechaIngreso: fechaFormateada
      };

      try { 
      const response = await fetch(`${server}/CrmOportunidads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(nuevaOportunidad)
      });

    

      if (response.ok) {

                    setNombreOportunidad('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    // handleSeleccionarOportunidad();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            
      

      // Limpiar campos
      setNombreOportunidad("");
      setValorMonetario("");
      setFechaCierre("");
      setProbabilidad("");
      setSelectedCliente(null);
      setSelectedOrigen(null);
      setSelectedSucursal(null);

    } catch (error) {
      Swal.fire("Error", error.message, "error");
      console.error("Error al guardar:", error);
    }

  } else {
    Swal.fire("Campos requeridos", "Completa todos los campos obligatorios.", "error");
    
  }
};


    return (
        <>
        {/* <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2> */}
        <br />
        <form onSubmit={handleSubmit} className="form-horizontal form-label-left" >
            <div className="item form-group">
            <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tituloOpor">
                    Titulo: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="tituloTarea"
                        required="required"
                        className="form-control"
                        value={nombreOportunidad}
                        onChange={(e) => setNombreOportunidad(e.target.value)}
                    />
                </div>
                <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="valorMonetarioOpor">
                    Valor monetario: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="descripcionTarea"
                        required="required"
                        className="form-control"
                        value={valorMonetario}
                        onChange={(e) => setValorMonetario(e.target.value)}
                    />
                </div>
            </div>

                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="fechaCierreOpor">
                    Fecha de cierre: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="date"
                            id="descripcionTarea"
                            required="required"
                            className="form-control"
                            value={fechaCierre}
                            onChange={(e) => setFechaCierre(e.target.value)}
                        />
                    </div>
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="etapaOpor">
                        Etapa de oportunidad: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={etapas}
                            getOptionLabel={(option) => option.etapa}
                            value={selectedEtapa}
                            onChange={(event, newValue) => setSelectedEtapa(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.id === value.idEtapaOportunidad}
                            disableClearable
                        />
                    </div>
                </div>
                <div className="item form-group">
                    {/* <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="probabilidadOpor">
                        Probabilidad: <span className="required"></span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="text"
                            id="prioridad"
                            required="required"
                            className="form-control"
                            value={probabilidad}
                            onChange={(e) => setProbabilidad(e.target.value)}
                        />
                    </div> */}
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="clienteOpor">
                        Cliente: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                                size="small"
                                freeSolo
                                fullWidth
                                options={clientes}
                                value={selectedCliente}
                                getOptionLabel={(option) => option?.nombreCompleto || ''}
                                inputValue={inputValue}
                                isOptionEqualToValue={(option, value) => option?.idCliente === value?.idCliente}
                                onInputChange={handleInputChange}
                                onChange={handleClienteSeleccionado}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        label="Buscar cliente"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="origenOpor">
                        Origen: <span className="required"></span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={origenes}
                            getOptionLabel={(option) => option.descripcion}
                            value={selectedOrigen}
                            onChange={(event, newValue) => setSelectedOrigen(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.idOrigen === value.idOrigen}
                            disableClearable
                        />
                    </div>
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="opcionesSucursal">
                        Sucursal: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={sucursales}
                            getOptionLabel={(option) => option.nombreSucursal}
                            value={selectedSucursal}
                            onChange={(event, newValue) => setSelectedSucursal(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.idSucursal === value.idSucursal}
                            disableClearable
                        />
                    </div>
                </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Oportunidad')}> Guardar
                    </button>
                </div>
            </div>
        </form>
    </>
    )
}


export default NewOportunidad;


